import { hasValue } from 'utils/hasValue';

import { useCryptoProvider } from 'hooks/useCryptoProvider';
import type { CryptoWidgetVariant } from 'hooks/useCryptoWidgetVariant';

import { BigedirectCryptoFundingContent } from './bigedirect/BigedirectCryptoFundingContent';
import { C2CCryptoFundingContent } from './c2c/C2CCryptoFundingContent';
import { CryptoWidget } from './tenant/CryptoWidget';
import { VirtualBankAccountProvider } from './tenant/shared/VirtualBankAccountProvider';

type CryptoFundingContentProps = {
  variant?: CryptoWidgetVariant;
};

export const CryptoFundingContent = ({
  variant
}: CryptoFundingContentProps) => {
  const { cryptoProvider } = useCryptoProvider();

  if (hasValue(cryptoProvider)) {
    return (
      <VirtualBankAccountProvider>
        <CryptoWidget />
      </VirtualBankAccountProvider>
    );
  }

  if (variant === 'bigedirect') {
    return <BigedirectCryptoFundingContent />;
  }
  if (variant === 'c2c') {
    return <C2CCryptoFundingContent />;
  }

  throw 'Crypto variant not supported';
};
